import { RequireAuth } from "@internal/auth";
import { useEffect } from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import { useOpenWeeks } from "@/hooks/useWeeks";
import { todayDayKeyInRange } from "@/lib/days";
import { landOnLoad, landOnReturn } from "@/lib/landing";
import { Arkiv } from "@/routes/Arkiv";
import { Cycle } from "@/routes/Cycle";
import { Day } from "@/routes/Day";
import { Innstillinger } from "@/routes/Innstillinger";
import { Layout } from "@/routes/Layout";
import { Report } from "@/routes/Report";
import { Week } from "@/routes/Week";
import { WeekTemplate } from "@/routes/WeekTemplate";

/** The landing rule (see CONTEXT.md). */
function Landing() {
  const { weeks, loading } = useOpenWeeks();
  if (loading) return <p>Laster…</p>;
  const today = new Date();
  for (const week of weeks) {
    const dayKey = todayDayKeyInRange(week.data.startDate, today);
    if (dayKey) {
      return (
        <Navigate
          to={`/uke/${encodeURIComponent(week.id)}/${dayKey}`}
          replace
        />
      );
    }
  }
  if (weeks.length > 0) {
    return <Navigate to={`/uke/${encodeURIComponent(weeks[0].id)}`} replace />;
  }
  return <Navigate to="/ukesmal" replace />;
}

landOnLoad();

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Landing /> },
      { path: "/ukesmal", element: <WeekTemplate /> },
      { path: "/arkiv", element: <Arkiv /> },
      { path: "/syklus/:cycleId", element: <Cycle /> },
      { path: "/uke/:weekId", element: <Week /> },
      { path: "/uke/:weekId/:dayKey", element: <Day /> },
      { path: "/innstillinger", element: <Innstillinger /> },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
  // Outside the Layout on purpose: the Period report is a page to print, and
  // a page with no app chrome prints as itself without a print stylesheet
  // having to know what the shell renders.
  { path: "/rapport", element: <Report /> },
]);

export function App() {
  useEffect(
    () => landOnReturn(() => router.navigate("/", { replace: true })),
    [],
  );
  return (
    <RequireAuth loadingFallback={<div>Laster…</div>}>
      <RouterProvider router={router} />
    </RequireAuth>
  );
}
